import { useTranslation } from "react-i18next"

import { Button } from "@/globalComponents/atoms/Button"
import Heading from "@/globalComponents/atoms/Heading"
import Text from "@/globalComponents/atoms/Text"
import Modal from "@/globalComponents/molecules/Modal"

interface Props {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  onConfirmDelete: () => Promise<void>
  isPending?: boolean
}

export function DeletePaymentMethodModal({
  isOpen,
  onOpenChange,
  onConfirmDelete,
  isPending,
}: Props) {
  const { t } = useTranslation("common")

  return (
    <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
      <Modal.Header isCloseDisabled={isPending}>
        <Heading level={2} slot="title">
          {t("removePaymentMethodModal.header")}
        </Heading>
      </Modal.Header>

      <Modal.Body>
        <Text level={1}>{t("removePaymentMethodModal.body")}</Text>
      </Modal.Body>

      <Modal.Footer arrangement="horizontal">
        {(state) => (
          <>
            <Button
              buttonType="default"
              isPending={isPending}
              onPress={state.close}
            >
              {t("common.back")}
            </Button>
            <Button
              buttonType="danger"
              isPending={isPending}
              onPress={async () => {
                try {
                  await onConfirmDelete()
                } finally {
                  state.close()
                }
              }}
            >
              {t("removePaymentMethodModal.confirm")}
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  )
}
